<!-- From Uiverse.io by Shell0110 -->
<button *ngIf="!viewModal" (click)="toggleFaq()" class="faq-button">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
    <path
      d="M80 160c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74V320c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7V160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ></path>
  </svg>
  <span class="tooltip">¿Que es PITZON?</span>
</button>

<div *ngIf="viewModal"
  class="absolute z-50 top-0 left-0 w-full landing-container backdrop-blur-sm bg-white/50 dark:bg-gray-900/50 animate__animated animate__backInDown"
>
<span class="close cursor-pointer bg-red-500 text-white z-10 px-2 py-1 rounded hover:bg-primary absolute top-2 right-2" (click)="closeModal()">X</span>
  <div class="content">
    <div class="logo-container">
      <div class="logo w-72">
        <!-- <span class="logo-text">Pitzon</span> -->
        <!-- <img [src]="currentImage" alt="Cover Image" class="w-full trapezoid animate__animated animate__fadeIn animate__delay-1s" /> -->
        <div class="bg-center pt-5 flex items-center justify-center animate__animated animate__fadeIn animate__delay-1s">
          <img
            *ngIf="isDarkMode === false"
            src="../../../../assets/images/logo/LOGO_tuulApp_Azul.png"
            alt="img"
            class="flex justify-center items-center animate__animated animate__fadeIn animate__delay-1s object-contain"
          />
          <img
            *ngIf="isDarkMode === true"
            src="../../../../assets/images/logo/LOGO_tuulApp_Blanco.png"
            alt="img"
            class="flex justify-center items-center animate__animated animate__fadeIn animate__delay-1s object-contain"
          />
        </div>
      </div>
    </div>
    <h1 class="title">{{ 'ACCESS-HOME.WELCOME' | translate }}</h1>
    <p class="subtitle text-black dark:text-white">
      PITZON es una app colombiana que conecta a conductores con talleres mecánicos confiables y certificados. Utiliza geolocalización e inteligencia artificial
      para encontrar el taller más cercano y adecuado, y ofrece un pre-diagnóstico del vehículo antes de llevarlo al taller. 🛠️📍🤖
    </p>

    <!-- <div class="buttons flex flex-col md:flex-row gap-4 w-full">
      <button class="btn btn-outline pulse-animation w-full md:w-1/2" (click)="goToassistant()">
        {{ 'ACCESS-HOME.VIRTUAL-ASSISTANT' | translate }}
      </button>
      <button class="btn btn-test w-full md:w-1/3" (click)="GoToLogin()">
        {{ 'ACCESS-HOME.LOGIN' | translate }}
      </button>
    </div> -->

    <div class="mt-6 block animate__animated animate__zoomInDown animated__delay-2s text-center">
      <span class="bg-dark p-1 rounded-full text-white text-xs m-1 inline-block cursor-pointer" *ngFor="let ser of services" (click)="chatAssistant(ser)">
        {{ ser }}
      </span>
    </div>

    <div class="features text-black dark:text-white">
      <div class="feature bg-gray-200 dark:bg-[#ffffff0d]">
        <div class="feature-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
          </svg>
        </div>
        <h3>{{ 'ACCESS-HOME.SECURITY' | translate }}</h3>
        <p>{{ 'ACCESS-HOME.SECURITY-SUBTITLE' | translate }}</p>
      </div>
      <div class="feature bg-gray-200 dark:bg-[#ffffff0d]">
        <div class="feature-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
        </div>
        <h3>{{ 'ACCESS-HOME.EFFICIENCY' | translate }}</h3>
        <p>{{ 'ACCESS-HOME.EFFICIENCY-SUBTITLE' | translate }}</p>
      </div>
      <div class="feature bg-gray-200 dark:bg-[#ffffff0d]">
        <div class="feature-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
        </div>
        <h3>{{ 'ACCESS-HOME.COLABORATIONS' | translate }}</h3>
        <p>{{ 'ACCESS-HOME.COLABORATIONS-SUBTITLE' | translate }}</p>
      </div>
    </div>
    <p class="text-black dark:text-white pt-5 animate__animated animate__backInDown animate__delay-1s">
      La mejor herramienta para el mantenimiento de tu vehículo, con la mejor experiencia de usuario. 🚗✨
    </p>
  </div>
</div>
